import { render, staticRenderFns } from "./GenderSelector.vue?vue&type=template&id=ef09e7d0&scoped=true&"
import script from "./GenderSelector.vue?vue&type=script&lang=ts&"
export * from "./GenderSelector.vue?vue&type=script&lang=ts&"
import style0 from "./GenderSelector.vue?vue&type=style&index=0&id=ef09e7d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef09e7d0",
  null
  
)

export default component.exports